import { render, staticRenderFns } from "./ObjectTable.vue?vue&type=template&id=27dac765"
import script from "./ObjectTable.vue?vue&type=script&lang=js"
export * from "./ObjectTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports